import { useEffect } from 'react';
import { FluentProvider, webLightTheme, webDarkTheme } from '@fluentui/react-components';
import { ErrorBoundary } from '@/features/error-boundary/ErrorBoundary';
import { OfficeProvider } from './providers/OfficeProvider';
import { QueryProvider } from './providers/QueryProvider';
import { PaneRouter } from './layout/PaneRouter';
import { AuthGate } from '@/features/landing/AuthGate';
import { useThemeMode } from '@/hooks/useThemeMode';

export function App() {
  const mode = useThemeMode();

  // Annonce au NAVIGATEUR le schéma dans lequel il doit dessiner ses propres
  // contrôles. Sans cela il reste en clair quel que soit le thème d'Outlook, et
  // l'icône de calendrier de `<input type="date">` — dessinée par Chromium, pas
  // par nous — est tracée en noir sur le fond sombre du champ : invisible. Les
  // ascenseurs natifs souffraient du même écart.
  //
  // Posé sur `<html>` et NON sur le FluentProvider ci-dessous, ce qui serait le
  // réflexe : `color-scheme` s'hérite par l'arbre DOM, et Fluent monte popovers,
  // menus et dialogues dans un portail rattaché à `<body>` — donc hors du
  // sous-arbre du provider. Les champs de date vivent justement dans un popover.
  useEffect(() => {
    document.documentElement.style.setProperty('color-scheme', mode);
  }, [mode]);

  return (
    <FluentProvider theme={mode === 'dark' ? webDarkTheme : webLightTheme}>
      <ErrorBoundary>
        <QueryProvider>
          <OfficeProvider>
            <AuthGate>
              <PaneRouter />
            </AuthGate>
          </OfficeProvider>
        </QueryProvider>
      </ErrorBoundary>
    </FluentProvider>
  );
}
